import { grayIconFill } from '../../../web/styles/colors';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	container: {
		alignItems: 'center',
		display: 'flex',
		paddingTop: 8,
	},
	dropDown: {
		maxWidth: 200,
		minWidth: 100,
	},
	dropDownOption: {
		fontSize: 14,
	},
	promptText: {
		color: grayIconFill,
		fontSize: 14,
		marginRight: 6,
	},
	removeButton: {
		marginLeft: 8,
	},
	toText: {
		fontSize: 14,
		margin: '0 8px',
	},
});
